import React from 'react';
import PropTypes from 'prop-types';
// https://reactdatepicker.com/#example-exclude-dates
// https://github.com/Hacker0x01/react-datepicker/
import 'AppSrc/core/style/components/form/form-base-components/sub-components/date-picker-header.css';

import {
  ChevronIconLeft,
  DoubleChevronIconLeft,
  DoubleChevronIconRight,
  ChevronIconRight,
} from 'AppSrc/core/components/common/svg-icons';
import moment from 'moment';

const DatePickerHeader = ({
  dateMoment,
  changeYear,
  decreaseMonth,
  increaseMonth,
}) => {

  const year = dateMoment.year();
  const currrentMonth = dateMoment.format('MMMM YYYY');

  return (
    <div className="date-picker-header">
      <button
        type="button"
        onClick={(e) => {
          e.preventDefault();
          changeYear(year - 1);
        }}
      >
        <div className="svg-wrapper">
          <DoubleChevronIconLeft />
        </div>
      </button>
      <button
        type="button"
        onClick={decreaseMonth}
      >
        <div className="svg-wrapper">
          <ChevronIconLeft />
        </div>
      </button>
      <h3 className="current-month">
        {currrentMonth}
      </h3>
      <button
        type="button"
        onClick={increaseMonth}
      >
        <div className="svg-wrapper">
          <ChevronIconRight />
        </div>
      </button>
      <button
        type="button"
        onClick={(e) => {
          e.preventDefault();
          changeYear(year + 1);
        }}
      >
        <div className="svg-wrapper">
          <DoubleChevronIconRight />
        </div>
      </button>
    </div>
  );
};

DatePickerHeader.propTypes = {
  dateMoment: PropTypes.instanceOf(moment),
  changeYear: PropTypes.func,
  decreaseMonth: PropTypes.func,
  increaseMonth: PropTypes.func,
};

export {
  DatePickerHeader,
};
